import React from "react"
import { MainCP } from "../../Components/seguimientoConstituyente_SOLO2023/MainCP"

const ViewSeguimientoConstituyente_SOLO2023: React.FC = () => <MainCP/>

export default ViewSeguimientoConstituyente_SOLO2023